require([
    'dayjs',
    'ch_utils',
    'jquery',
    'semantic',
    'services',
    'ch_header',
    'ch_form_validation',
    'semantic-calendar',
    'ch_semantic_responsive',
    'ch_welcome_overlay'
], function(dayjs, utils) {

    var types = {
        EMAIL:'Email',
        PRINT:'Print',
        MAIL:'Mail'
    };
    var maxCount = 500;
    var $giftCardThumbs;
    var $mainImage;
    var $selectCategory;
    var $templateField;
    var $characterCounter;

    function recalculateGiftCardDeal() {
        var $form = $('#form_GiftCard');
        var $giftCardDealSection = $('#gift-card-deal-section');
        var amountOff;
        var amount;

        $giftCardDealSection.hide();

        if (CH.giftCardDealValue) {
            amount = $('input[name=amount]', $form).val();
            amountOff = (CH.giftCardDealValue * amount / 100);
            if (CH.giftCardDealMaxSavingsAmount) {
                amountOff = Math.min(amountOff, CH.giftCardDealMaxSavingsAmount).toFixed(2);
            }

            $('.js-gift-card-deal', $giftCardDealSection).html(utils.formatToUSD(amountOff));
            $('.js-gift-card-deal-total', $giftCardDealSection).html(
                utils.formatToUSD(Number(amount - amountOff))
            );

            if (amount) {
                $giftCardDealSection.show();
            }
        }
    }

    function setAmountChange(value) {

        if (value == "CUSTOM") {
            if(CH.hasSection) {
                CH.hasSection = false;
            } else {
                $._('amount').val(null);
            }

            $._('custom_value').show();
        } else {
            $._('amount').val(value);
            $._('custom_value').hide();
        }

        recalculateGiftCardDeal();
    }

    // Helper function performs actual GiftCard image selection
    function selectGiftCardImage(target) {

        // set new selected thumb
        $giftCardThumbs.removeClass('selected');
        target.addClass('selected');

        // change main image
        $mainImage.attr('src',
            target.find('.thumbnail').attr('src')
        );

        // make sure form is all set
        $templateField.val(target.data('id'));
    }

    function updateGiftCardTemplateOptions(deliveryType) {
        if (deliveryType == types.MAIL) {
            selectGiftCardImage($('#all-class-types'));
            $('#select_category').dropdown('set selected', 'all-class-types').addClass('disabled');
            $('#select-category-field').hide();
            $('.js-gift-card:not(#all-class-types)').hide();
        } else {
            $('.js-gift-card:not(#all-class-types)').show();
            $('#select-category-field').show();
            $('#select_category').dropdown().removeClass('disabled')
        }
    }

    // Bind event handler for this page
    function initEventHandlers() {

        // Handler for selection of thumbnail images
        $giftCardThumbs.on('click', function(e) {
            e.preventDefault();
            selectGiftCardImage($(this));
            $selectCategory.dropdown('set selected', $(this).attr('id'));
        });

        // Handler for select class category
        $selectCategory.dropdown({
            onChange: function(value) {
                selectGiftCardImage($('#' + value));
            }
        });

        // Email vs Mail type chosen
        $._('type').dropdown({
            fireOnInit: true,
            onChange: function(value, text, $selectedItem) {
                if (value == types.MAIL) {
                    $._('email-preferences').hide();
                    $._('email-preferences').find('input, select').disable();

                    $._('mail-preferences').show();
                    $._('mail-preferences').find('input', 'select').enable();
                    $._('state').enable();

                    $._('delivery-date-mail').show();
                    $._('delivery-date-mail').enable();

                    $._('delivery-date').hide();
                    $._('delivery-date').find('input, select').disable();
                } else if (value == types.PRINT) {
                    $._('mail-preferences').hide();
                    $._('mail-preferences').find('input').disable();
                    $._('state').disable();

                    $._('email-preferences').hide();
                    $._('email-preferences').find('input, select').disable();

                    $._('delivery-date-mail').hide();
                    $._('delivery-date-mail').disable();

                    $._('delivery-date').hide();
                    $._('delivery-date').find('input, select').disable();
                } else if (value == types.EMAIL) {
                    $._('mail-preferences').hide();
                    $._('mail-preferences').find('input', 'select').disable();
                    $._('state').disable();

                    $._('email-preferences').show();
                    $._('email-preferences').find('input, select').enable();

                    $._('delivery-date-mail').hide();
                    $._('delivery-date-mail').disable();

                    $._('delivery-date').show();
                    $._('delivery-date').find('input, select').enable();
                }

                updateGiftCardTemplateOptions(value);
            }
        });

        $._('amount').blur(function(e){
            recalculateGiftCardDeal();
        });

        $("#description").on('input', function(e) {
            characterCounter(this, maxCount, $characterCounter);
        });

        $('.delivery_date').calendar({
            type: 'date',
            minDate: new Date(),
            formatter: {
                date: function (date, settings) {
                    return dayjs(date).format('MM/DD/YYYY');
                }
            }
        });

        if (CH.isMobile) {
            // Custom value chosen under set_amount?
            $._('set_amount').change(function() {
                var value = $(this).val();
                setAmountChange(value);
            });

            $._('set_amount').trigger("change");

        } else {

            // Custom value chosen under set_amount?
            $._('set_amount').dropdown({
                fireOnInit: true,
                onChange: function(value, text, $selectedItem) {
                    setAmountChange(value);
                }
            });
        }

        $('.ui.accordion').accordion({
            exclusive: false
        });
    }

    $(function() {
        // select the things
        $giftCardThumbs = $('.js-gift-card');
        $mainImage = $('#selected-gift-card img');
        $selectCategory = $('#select_category');
        $templateField = $('#template_id');
        $characterCounter = $("#characters-remaining");

        // initialize form
        CH.validate('form_GiftCard', {
            rules: {
                description: {
                    maxlength: 500
                },
                from: CH.validationRules.fromMultiple,
                name: CH.validationRules.multipleNames,
            },
        });

        // set up all the page events
        initEventHandlers();
    });
});
